import { render, staticRenderFns } from "./TextExcerpt.vue?vue&type=template&id=1fd710d0"
import script from "./TextExcerpt.vue?vue&type=script&lang=ts"
export * from "./TextExcerpt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports